import React from 'react'
import useI18n from 'hooks/useI18n'
import styled from 'styled-components'
import { Text, Flex, Link, LinkExternal } from '@pancakeswap-libs/uikit'


export interface ExpandableSectionProps {
  str:string
}

const Wrapper = styled.div`
  margin-top: 24px;
`

const Text2 = styled(Text)`
  font-size: 14px;
`
const ExplainUl=styled.ul`
    list-style-type: none;
    margin-top: 16px;
    padding: 0px;
    list-style: inside disc;
    max-width: 310px;
    li{
        color: ${({ theme }) => theme.isDark?theme.colors.textSubtle:'rgb(122, 110, 170)'};
    }
`
const TextDeclare=styled.div`
    color: ${({ theme }) => theme.isDark?theme.colors.textSubtle:'rgb(122, 110, 170)'};
    font-weight: 400;
    line-height: 1.5;
    font-size: 12px;
    text-align: center;
    display: inline;
`

export interface RioInfoProps {
  pledgeMode:number
  baseApr: string
  apy: string
  multiplier: string
}

const RoiInfo: React.FC<RioInfoProps> = ({
  pledgeMode,
  baseApr,
  apy,
  multiplier
}) => {
  const TranslateString = useI18n();
  return (
    <Wrapper>
      <Flex justifyContent="space-between">
         <Text2>{TranslateString(704,'Base APR (EBEN yield only)')}</Text2>
         <Text2>{baseApr}</Text2>
     </Flex>
     <Flex justifyContent="space-between">
         <Text2>{TranslateString(705,'APY (1x daily compound)')}</Text2>
         <Text2>{apy}</Text2>
     </Flex>
     <Flex justifyContent="space-between">
         {pledgeMode!==2?
          <>
           <Text2>{TranslateString(706,'Farm Multiplier')}</Text2>
           <Text2>{multiplier}</Text2>
          </>
          :''
         }
     </Flex>
     <ExplainUl>
         <li><TextDeclare>{TranslateString(707,'Calculated based on current rates.')}</TextDeclare></li>
         {pledgeMode===0 || pledgeMode===2?
         <li><TextDeclare>{TranslateString(708,'LP rewards: 0.15% trading fees, distributed proportionally among LP token holders.').replace(/&#37;/g,"%")}</TextDeclare></li>
         :''}
         <li><TextDeclare>{TranslateString(709,'All figures are estimates provided for your convenience only, and by no means represent guaranteed returns.')}</TextDeclare></li>
     </ExplainUl>
      {/* <Flex justifyContent="flex-start">
      {TranslateString(95,'View on Smartscout')}
      </Flex> */}
    </Wrapper>
  )
}

export default RoiInfo
